var map = {
	"./": 18305,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Pages/Home/Experiences/Experiences": 25206,
	"./Pages/Home/Experiences/Experiences.css": 29750,
	"./Pages/Home/Experiences/Experiences.js": 25206,
	"./Pages/Home/FAQ/FAQ": 13068,
	"./Pages/Home/FAQ/FAQ.css": 2478,
	"./Pages/Home/FAQ/FAQ.js": 13068,
	"./Pages/Home/Feature/Feature": 49632,
	"./Pages/Home/Feature/Feature.css": 28388,
	"./Pages/Home/Feature/Feature.js": 49632,
	"./Pages/Home/Features/Features": 66045,
	"./Pages/Home/Features/Features.css": 71489,
	"./Pages/Home/Features/Features.js": 66045,
	"./Pages/Home/Hero/Hero": 60761,
	"./Pages/Home/Hero/Hero.css": 35601,
	"./Pages/Home/Hero/Hero.js": 60761,
	"./Pages/Home/Home/Home": 50618,
	"./Pages/Home/Home/Home.css": 10897,
	"./Pages/Home/Home/Home.js": 50618,
	"./Pages/Home/Service/Service": 2215,
	"./Pages/Home/Service/Service.css": 53712,
	"./Pages/Home/Service/Service.js": 2215,
	"./Pages/Home/Services/Services": 10952,
	"./Pages/Home/Services/Services.css": 10230,
	"./Pages/Home/Services/Services.js": 10952,
	"./Pages/Home/Testimonials/Testimonials": 41453,
	"./Pages/Home/Testimonials/Testimonials.css": 86008,
	"./Pages/Home/Testimonials/Testimonials.js": 41453,
	"./Pages/Shared/Footer/Footer": 12541,
	"./Pages/Shared/Footer/Footer.css": 13833,
	"./Pages/Shared/Footer/Footer.js": 12541,
	"./Pages/Shared/Header/Header": 52198,
	"./Pages/Shared/Header/Header.css": 15235,
	"./Pages/Shared/Header/Header.js": 52198,
	"./images/close-icon.svg": 48067,
	"./images/doctors/doctor1.png": 29385,
	"./images/doctors/doctor2.png": 38301,
	"./images/doctors/doctor3.png": 15850,
	"./images/doctors/doctor4.png": 92175,
	"./images/experiences/blood-pressure.png": 11297,
	"./images/experiences/first-aid.png": 28069,
	"./images/experiences/group-10.png": 46955,
	"./images/experiences/plastrer.png": 5798,
	"./images/experiences/pose_4.png": 48108,
	"./images/faqs/blood-pressure.png": 86444,
	"./images/faqs/defibrillator.png": 66274,
	"./images/faqs/ellipse10.png": 223,
	"./images/faqs/ellipse11.png": 86837,
	"./images/faqs/experts.png": 92953,
	"./images/faqs/gloves.png": 60413,
	"./images/faqs/group-26.png": 92420,
	"./images/faqs/pose_8.png": 98629,
	"./images/features/ellipse.png": 87054,
	"./images/features/feature1.png": 89313,
	"./images/features/feature2.png": 15767,
	"./images/features/feature3.png": 21673,
	"./images/features/feature4.png": 25630,
	"./images/features/group.png": 29409,
	"./images/features/pose_7.png": 40758,
	"./images/footer/design_instagram.svg": 87559,
	"./images/footer/design_twitter.svg": 92116,
	"./images/footer/facebook.svg": 53873,
	"./images/footer/icons_google.svg": 5435,
	"./images/footer/icons_youtube.svg": 73729,
	"./images/hero-group.svg": 16286,
	"./images/hero-left-shape.png": 71405,
	"./images/hero-right-bg.png": 53895,
	"./images/hero-right-shape.png": 16191,
	"./images/hero-vector.svg": 42463,
	"./images/logo.png": 96338,
	"./images/menu-icon.svg": 50418,
	"./images/pose_2.png": 22249,
	"./images/rectangle1.png": 6333,
	"./images/rectangle2.png": 71351,
	"./images/services/service1.png": 94223,
	"./images/services/service2.png": 22521,
	"./images/services/service3.png": 48654,
	"./images/services/service4.png": 35032,
	"./images/testimonials/ikbal1.png": 70657,
	"./images/testimonials/left-arrow.png": 56865,
	"./images/testimonials/ornament-1.png": 31617,
	"./images/testimonials/ornament-2.png": 68468,
	"./images/testimonials/ornament-3.png": 43831,
	"./images/testimonials/right-arrow.png": 86139,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;